<template>
  <div id="contenedor-marcar-concepto-como-favorito"
    :class="block ? 'd-block' : 'd-inline-block'">
    <template
      v-if="tipo === 'estrella'">
      <v-tooltip top>
        <template
          v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            :color="esFavorito ? 'yellow' : ''"
            v-bind="attrs"
            v-on="on"
            :disabled="enviandoFormulario"
            @click.prevent="mixMarcarComoFavorito">
            <v-icon>
              <template
                v-if="esFavorito">
                mdi-star
              </template>
              <template
                v-else>
                mdi-star-outline
              </template>
            </v-icon>
          </v-btn>
        </template>
        <span>
          Marcar como favorito
        </span>
      </v-tooltip>
    </template>
    <template
      v-else>
      <v-switch
        label="Marcar Favorito"
        color="warning"
        hide-details
        inset
        :disabled="enviandoFormulario"
        @change="mixMarcarComoFavorito">
      </v-switch>
    </template>
  </div>
</template>

<script>
import mixCatalogo from './mixCatalogo';

export default {
  name: 'MarcarConceptoComoFavorito',
  mixins: [mixCatalogo],
  props: {
    id: {
      type: String,
      required: true,
    },
    esFavorito: {
      type: Boolean,
      required: false,
      default: false,
    },
    tipo: {
      type: String,
      required: false,
      default: 'estrella',
    },
    block: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
};
</script>

<style lang="scss">

</style>
